import { atom } from "recoil";

export const showSignInorUpState = atom({
  key: "showSignInorUpState",
  default: false
});